export default __webpack_public_path__ + "static/media/services_step_window.d4d0ceef.svg";